export const dateString2BPMSFormat = (date: any) => {
    if (!date) return "";
    const dateString = date.toString().split('-')
    const day = dateString[2]
    const month  = dateString[1]
    const year = dateString[0]
    const result = `${day}/${month}/${year}`
    return result;
  };